import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FiltersForm } from '../components/FiltersForm';
import { SvgBarChart } from '../components/SvgBarChart';
import { Table } from '../components/Table';
import { DownloadMenu } from '../components/DownloadMenu';
import { Section } from '../components/Section';
import { topSchema } from '../validation';
import { useKpiTop, useQueryParams } from '../hooks/useKpi';
import type { TopParams } from '../types';

const defaults: TopParams = { collection: '', groupBy: '', limit: 10 };

export default function Top() {
  const [search] = useSearchParams();
  const merged = useQueryParams(defaults, search) as any;
  const [params, setParams] = useState<TopParams | undefined>(merged.collection ? merged : undefined);
  const query = useKpiTop(params);

  return (
    <Section title="Top" description="Agrupa y ordena resultados">
      <FiltersForm defaultValues={merged} schema={topSchema} fields={[{ name: 'collection', label: 'Colección' }, { name: 'groupBy', label: 'Agrupar por' }, { name: 'limit', label: 'Límite', type: 'number' }]} onSubmit={(values) => setParams(values)} />
      {query.isLoading && <p>Cargando...</p>}
      {query.error && <p className="text-red-600">Error al cargar</p>}
      {query.data && <div className="space-y-4"><SvgBarChart data={query.data.map((d) => ({ label: d.key, value: d.value }))} /><DownloadMenu filename="top" rows={query.data as any} /><Table rows={query.data as any} /></div>}
    </Section>
  );
}
